const app_version = 'tianfu-web'
import LocalData from '@/utils/local_data'
const { VUE_APP_TYPE } = process.env

const isProd = process.env.NODE_ENV === 'production'

export default (pageName, adIndex) => {
    if (isProd) {
    }
}
export const sendCtmEvtLog = (evt_name, d_paras) => {
    if (!evt_name) {
        return
    }
    console.error(evt_name)
    sendUserLog('fc_event_record', {
        d_key: evt_name,
        d_paras,
        d_event: 1
    })
}
export const sendUserLog = async (type, options) => {
    if (isProd) {
        if (typeof options.d_paras != 'object') {
            options.d_paras = {}
        }
        options.d_src = type
        options.d_paras.app_type = VUE_APP_TYPE
        const user = await LocalData.user.get()
        options.d_user = user.uid
        const data = [options]
        fetch('https://ff3.gfttek.com/anyfin/ext/rtlog', {
            method: "post",
            body: JSON.stringify(data)
        })
    }
}

export const UserLog = {
    userLogin () {
        const name = {
        'tft': '成都购房通',
        'tfsmy': '天府市民云打开'
        }[VUE_APP_TYPE]
        sendCtmEvtLog(name)
    },
    viewBuilding: (building_id, scene) => {
        if (!building_id) {
            return
        }
        sendUserLog('fc_building_view', {
            d_key: building_id,
            d_paras: scene,
            d_event: 1
        })
    },
    buildingAudios (building_id, d_paras) {
        if (!building_id) {
            return
        }
        sendUserLog('fc_building_audio', {
            d_key: building_id.toString(),
            d_paras,
            d_event: 1
        })
    },
    viewBuildingSunlight (building_id, building_name) {
        if (!building_id) {
            return
        }
        sendUserLog('fc_building_sunlight', {
            d_key: building_id,
            d_paras: {
                building_name
            },
            d_event: 1
        })
    },
    viewBuildingVr: (building_id, building_name, vr_link) => {
        if (!building_id) {
            return
        }
        sendUserLog('fc_building_vr_view', {
            d_key: building_id,
            d_paras: {
                building_name,
                vr_link
            },
            d_event: 1
        })
    },
    viewPage: (page) => {
        if (!page) {
            return
        }
        sendUserLog('fc_page_view', {
            d_key: page,
            d_event: 1
        })
    },
    viewCustomBuilding: (buildingId) => {
        sendUserLog('fc_building_custom_view', {
            d_key: buildingId,
            d_event: 1
        })
    },
    viewConsultant: (consultantId) => {
        sendUserLog('fc_consultant_view', {
            d_key: consultantId,
            d_event: 1
        })
    },
    callConsultant: (consultantId) => {
        if (!consultantId) {
            return
        }
        sendUserLog('fc_consultant_call', {
            d_key: consultantId.toString(),
            d_event: 1
        })
    },
    copyConsultant: (consultantId, building_id) => {
        if (!consultantId) {
            return
        }
        sendUserLog('fc_consultant_copy', {
            d_key: consultantId.toString(),
            d_event: 1,
            d_paras: {
                building_id
            }
        })
    },
    contactConsultant: (consultantId) => {
        if (!consultantId) {
            return
        }
        sendUserLog('fc_consultant_contact', {
            d_key: consultantId.toString(),
            d_event: 1
        })
    },
    searchHouse: (searchWord, ids) => {
        sendUserLog('fc_user_search', {
            d_key: searchWord.substring(0, 64),
            d_paras: ids,
            d_event: 0
        })
    },
    regSearch: (buildingId, searchWord) => {
        sendUserLog('fc_reg_results', {
            d_key: buildingId,
            d_paras: searchWord,
            d_event: 0
        })
    },
    lnSearch: (buildingId, searchWord) => {
        sendUserLog('fc_ln_results', {
            d_key: buildingId,
            d_paras: searchWord,
            d_event: 0
        })
    },
    evaluate_2nd_hand: (param, result) => {
        sendUserLog('fc_evaluate_2nd_hand', {
            d_key: JSON.stringify(param),
            d_paras: JSON.stringify(result),
            d_event: 0
        })
    },
    click_feeds_article: (id) => {
        sendUserLog('fc_feeds_article_click', {
            d_key: id.toString(),
            d_event: 0
        })
    },
    click_discuss_group: (id) => {
        if (id) {
           sendUserLog('fc_discuss_group_click', {
                d_key: id.toString(),
                d_event: 0
            })
        }
    },
    vanke_banner: (id, d_event) => {
        if (id) {
            sendUserLog('fc_vanke_banner', {
                 d_key: id.toString(),
                 d_event
             })
         }
    },
    click_article: (type, id) => {
        if (type && id) {
            sendUserLog('fc_article_click', {
                d_key: id.toString(),
                d_event: 0,
                d_paras: {
                    type
                }
            })
        }
    }
}

export const errorLog = (msg) => {
    console.error('error log', msg)
    if (isProd) {
    }
}



export const imgErrorLog = (msg, other) => {
    errorLog(`ImgError: ${msg}`)
}
export const requestErrorLog = (msg, other) => {
    const msgStr = JSON.stringify(msg)
    const otherStr = JSON.stringify(other)
    errorLog(`RequestError: ${msgStr}; ${otherStr};`)
}

export const requestProfileLog = (msg, other) => {
    const segments = [
        'domainLookUp',
        'connect',
        'SSLconnection',
        'request',
        'response'
    ]
    let slow_reason = 'slow_reason:'
    const is_slow_request = segments.some((key) => {
        const time = msg[`${key}End`] - msg[`${key}Start`]
        if (time > 1000) {
            slow_reason += key
            return true
        }
    })
    if (is_slow_request) {
        const msgStr = JSON.stringify(msg)
        const otherStr = JSON.stringify(other)
        errorLog(`RequestProfile: ${slow_reason}; ${msgStr}; ${otherStr};`)
    }
}


